import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

const FAEventCardActions = ({ exportToExcel }) => {
  return (
    <Permissions
      permissions="familyAlbum.downloadCustomerEmails"
      render={() => (
        <Card.Content extra>
          <List>
            <a href="#download">
              <CardProperty onClick={exportToExcel} icon="file excel outline" popUpContent="Download Customer Emails">
                Download Emails
              </CardProperty>
            </a>
          </List>
        </Card.Content>
      )}
    />
  )
}

FAEventCardActions.propTypes = {
  exportToExcel: PropTypes.func.isRequired,
}

export default FAEventCardActions
